import * as dis2 from '../../dispossitions/dispossitions.const';
import {DONATION, GRANT_AWARD, OTHER_FEE} from '../payamnets.const';

export const ACTIVITY_TYPE_FUNDRAISING = 'Fundraising';
export const ACTIVITY_TYPE_GRANT_MANAGEMENT = 'Grant Management';
export const ACTIVITY_TYPE_GRANT_WRITING = 'Grant Writing';
export const ACTIVITY_TYPE_GRANT_RESEARCH = 'Grant Research';
export const ACTIVITY_TYPE_OD_OTHER = 'Other';
//
export const ACTIVITY_TYPE_FUNDRAISING_ID = '65f092bc2d71dfb4e188013e';
export const ACTIVITY_TYPE_GRANT_MANAGEMENT_ID = '65f062bc2d71dfb4e488012e';
export const ORGANIZATIONAL_DEVELOPMENT_ID = '65f062bc2d71dfb4e188014e';
export const ACTIVITY_TYPE_GRANT_WRITING_ID = '66f062bc2d71dfb4e188115e';
export const ACTIVITY_TYPE_GRANT_RESEARCH_ID = '65f062bc2d91dfb4e188016e';
export const ACTIVITY_TYPE_OD_OTHER_ID = '65f062bc3d71dfb4e188117e';

export const GRANT_MA = {
    _id: ACTIVITY_TYPE_GRANT_MANAGEMENT_ID,
    label: ACTIVITY_TYPE_GRANT_MANAGEMENT,
    defaultDisposition: dis2.OD_GM_ONGOING,
    dispositions: [dis2.OD_GM_ONGOING, dis2.OD_GM_CLOSED],
    paymentIn: [GRANT_AWARD, OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const FUND_RA = {
    _id: ACTIVITY_TYPE_FUNDRAISING_ID,
    label: ACTIVITY_TYPE_FUNDRAISING,
    dispositions: [dis2.OD_FR_PLANNING, dis2.OD_FR_ONGOING, dis2.OD_FR_CLOSED],
    defaultDisposition: dis2.OD_FR_PLANNING,
    paymentIn: [DONATION, OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const GRANT_WRITING = {
    _id: ACTIVITY_TYPE_GRANT_WRITING_ID,
    label: ACTIVITY_TYPE_GRANT_WRITING,
    defaultDisposition: dis2.OD_GW_INPROCESS,
    dispositions: [dis2.OD_GW_INPROCESS, dis2.OD_GW_SUBMITTED, dis2.OD_GW_ACCEPTED, dis2.OD_GW_REJECTED],
    paymentIn: [GRANT_AWARD, OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const GRANT_RESEARCH = {
    _id: ACTIVITY_TYPE_GRANT_RESEARCH_ID,
    label: ACTIVITY_TYPE_GRANT_RESEARCH,
    dispositions: [dis2.OD_GR_ONGOING, dis2.OD_GR_COMPLETED],
    defaultDisposition: dis2.OD_GR_ONGOING,
    paymentIn: [GRANT_AWARD, OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const OD_OTHER = {
    _id: ACTIVITY_TYPE_OD_OTHER_ID,
    label: ACTIVITY_TYPE_OD_OTHER,
    defaultDisposition: dis2.OD_OTH_ONGOING,
    dispositions: [dis2.OD_OTH_ONGOING, dis2.OD_OTH_CLOSED, dis2.OD_OTH_OTHER],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE],
};

export const ORGANIZATIONAL_DEVELOPMENT = {
    _id: ORGANIZATIONAL_DEVELOPMENT_ID,
    label: 'CMC Development',
    icon: 'organizationalDevelopment',
    description: 'Activities related to raising funds for the CMC',
    subTypes: [GRANT_MA, FUND_RA, GRANT_WRITING, GRANT_RESEARCH, OD_OTHER],
};
